/**
 * Why a 360's settings cannot be changed here: the confidentiality is final once launched, both settings are
 * owned by the cycle the 360 belongs to, and none changes once the 360 is over.
 */
export const Feedback360SettingsLock = {
    LAUNCHED: 'launched',
    INHERITED: 'inherited',
    COMPLETED: 'completed',
} as const;

export type Feedback360SettingsLockValue =
    (typeof Feedback360SettingsLock)[keyof typeof Feedback360SettingsLock];

/** Why a reply field is gone: replies are turned off for a 360 feedback, or for an evaluation. */
export const repliesClosedCopy = (is360: boolean) =>
    is360
        ? ('reviewAnswer.commentThread.repliesClosed360' as const)
        : ('reviewAnswer.commentThread.repliesClosed' as const);

/** A new 360 lets managers reply to its comments until its creator turns replies off. */
export const NEW_FEEDBACK_360_COMMENT_REPLIES_ENABLED = true;
